var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConsultationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.70323 11.7124C9.44698 11.1843 9.11573 10.7999 8.54386 11.0343L7.41573 11.453C6.51261 11.8718 6.06261 11.453 5.60948 10.8218L3.57823 6.20304C3.32198 5.67492 3.45636 5.17804 4.02823 4.94367L5.60636 4.31242C6.17823 4.07492 6.08761 3.58117 5.83136 3.05304L4.47823 0.53429C4.22198 0.0061655 3.69698 -0.12196 3.12511 0.112415C1.98448 0.584291 1.03448 1.32492 0.421981 2.42179C-0.328019 3.76242 0.0469808 5.62804 0.196981 6.41242C0.346981 7.19679 0.871981 8.57179 1.55011 9.98116C2.22823 11.3937 2.82198 12.503 3.35323 13.1312C3.88448 13.7593 5.15948 15.478 6.73761 15.8624C8.03136 16.1749 9.42823 15.9124 10.572 15.4405C11.147 15.2062 11.147 14.7093 10.8907 14.178L9.70323 11.7124ZM15.9751 6.14992H10.4345L12.897 3.68742H11.0501L7.97198 6.76554L11.0501 9.84367H12.897L10.4345 7.38117H15.9751V6.14992Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultationIcon);
export default __webpack_public_path__ + "static/media/consultationIcon.967bc14987de5ee562eb540c632f0f66.svg";
export { ForwardRef as ReactComponent };